import { render, staticRenderFns } from "./CorContractList.vue?vue&type=template&id=6aaf45fa&"
import script from "./CorContractList.vue?vue&type=script&lang=js&"
export * from "./CorContractList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports